/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketVehicleRequest model module.
 * @module model/PerplayStatisticsControllerDtoMarketVehicleRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketVehicleRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketVehicleRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketVehicleRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoMarketVehicleRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketVehicleRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketVehicleRequest} The populated <code>PerplayStatisticsControllerDtoMarketVehicleRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketVehicleRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = ApiClient.convertToType(data['nftType'], 'Number');
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = ApiClient.convertToType(data['nftGrade'], 'String');
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = ApiClient.convertToType(data['nftSeal'], 'String');
            }
            if (data.hasOwnProperty('isPlus')) {
                obj['isPlus'] = ApiClient.convertToType(data['isPlus'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketVehicleRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketVehicleRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoMarketVehicleRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['nftGrade'] && !(typeof data['nftGrade'] === 'string' || data['nftGrade'] instanceof String)) {
            throw new Error("Expected the field `nftGrade` to be a primitive type in the JSON string but got " + data['nftGrade']);
        }
        // ensure the json data is a string
        if (data['nftSeal'] && !(typeof data['nftSeal'] === 'string' || data['nftSeal'] instanceof String)) {
            throw new Error("Expected the field `nftSeal` to be a primitive type in the JSON string but got " + data['nftSeal']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoMarketVehicleRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoMarketVehicleRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoMarketVehicleRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} nftType
 */
PerplayStatisticsControllerDtoMarketVehicleRequest.prototype['nftType'] = undefined;

/**
 * @member {String} nftGrade
 */
PerplayStatisticsControllerDtoMarketVehicleRequest.prototype['nftGrade'] = undefined;

/**
 * @member {String} nftSeal
 */
PerplayStatisticsControllerDtoMarketVehicleRequest.prototype['nftSeal'] = undefined;

/**
 * @member {Boolean} isPlus
 */
PerplayStatisticsControllerDtoMarketVehicleRequest.prototype['isPlus'] = undefined;






export default PerplayStatisticsControllerDtoMarketVehicleRequest;

